/**
 * Scopes for access tokens aimed at the Nature4D API (must match backend ENTRA_AUDIENCE / exposed API).
 *
 * Prefer REACT_APP_ENTRA_API_SCOPE (e.g. api://xxxx/access_as_user or api://xxxx/.default).
 * Else derive from REACT_APP_ENTRA_AUDIENCE + /.default (same URI family as Terraform entra_audience).
 */
export function getApiScopes() {
  const explicit = process.env.REACT_APP_ENTRA_API_SCOPE?.trim();
  if (explicit) {
    return explicit.split(/[\s,]+/).filter(Boolean);
  }
  const audience = process.env.REACT_APP_ENTRA_AUDIENCE?.trim();
  if (!audience) {
    return [];
  }
  const base = audience.replace(/\/$/, "");
  return [`${base}/.default`];
}
